import React, { Component } from 'react';
class PrivacyPolicyInfo extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
      <div className="container-xxl mt-5">
          <div className="container inner_con">

              <div className="row g-4 mb-5" id="corporate_capital_markets">
                  <h2 className="text-start mb-2 wow fadeInUp title_view" data-wow-delay="0.1s">PRIVACY POLICY</h2>
                  <div className="col-lg-12 wow fadeIn mt-2" data-wow-delay="0.5s">

                  <h4 className="mb-4"><spam className="card_title">BYLAWS Legal LLP</spam></h4>
                  <p className="mb-3">1. Introduction and Purpose</p>
                  <p className="mb-3">
                  BYLAWS Legal LLP (“BYLAWS”, “the Firm”, “we”, “our” or “us”) is a limited liability partnership engaged in the practice of law
                  and allied professional services through advocates and legal professionals. The Firm recognises the importance of
                  protecting personal data, sensitive personal information, confidential information and legally privileged material entrusted to
                  it in the course of its professional engagements and business operations. This Privacy Policy has been adopted to set out
                  the manner in which BYLAWS collects, uses, processes, stores, discloses, and safeguards personal data in accordance
                  with applicable laws, professional obligations and ethical standards governing advocates in India.
                  </p>

                  <p className="mb-3">
                  This Policy is intended to reduce legal, regulatory, and professional risk to the Firm by clearly defining the scope, purpose,
                  and limitations of data processing activities undertaken by BYLAWS. It reflects compliance with the applicable laws,
                  confidentiality obligations and Bar Council of India norms.
                  </p>

                  <p className="mb-3">
                  This Policy does not create any contractual rights in favour of any individual and shall not be construed as imposing
                  obligations beyond those required under law or professional ethics. The Firm reserves the right to interpret and apply this
                  Policy in a manner consistent with legal requirements and the nature of professional legal services.
                  </p>

                  <p className="mb-3">2. Scope and Applicability</p>

                  <p className="mb-3">This Privacy Policy applies to all personal data processed by BYLAWS in connection with its legal practice, regulatory
                  advisory, transactional support, litigation services, internal administration and business operations. It covers data relating to
                  clients, prospective clients, counterparties, witnesses, experts, consultants, advisors, employees, interns and any other
                  individuals whose personal data may be processed by the Firm.
                  </p>

                  <p className="mb-3">
                  The Policy applies irrespective of the mode of data collection, including physical documents, electronic communications,
                  emails, telephonic interactions, video conferencing, website submissions, regulatory filings, court records and third-party
                  sources lawfully accessed in the course of legal representation. Given the nature of legal practice, BYLAWS may process
                  personal data received directly from data principals as well as data received from clients, courts, regulators, opposing
                  parties, investigators and other lawful sources.
                  </p>

                  <p className="mb-3">
                  This Policy applies only to data processed by BYLAWS in its capacity as a law firm and does not extend to third-party
                  websites, platforms, or service providers that may be linked to or referenced by the Firm. The scope of this Policy is
                  intentionally broad to ensure that all data processing activities undertaken by the Firm are governed by a uniform and
                  risk-managed framework.
                  </p>

                  <p className="mb-3">3. Categories of Information Collected</p>

                  <p className="mb-3">
                  In the course of its professional activities, BYLAWS may collect and process various categories of personal data, depending
                  on the nature of the engagement and legal requirements. Such data may include basic personal information. Where
                  required for legal representation, regulatory compliance or litigation, the Firm may also process financial information,
                  transaction records, corporate data and ownership details.
                  </p>

                  <p className="mb-3">
                  In certain matters, particularly litigation, employment, healthcare, regulatory or criminal matters, the Firm may process
                  sensitive personal data or special category data, including information relating to health, financial status, criminal
                  allegations, regulatory proceedings or other sensitive matters. Such data is collected strictly on a need-to-know basis and
                  only to the extent necessary for the lawful provision of legal services.
                  </p>

                  <p className="mb-3">
                  Additionally, the Firm processes confidential client information, legally privileged communications, pleadings, evidence,
                  opinions, strategy documents and internal work product. All such information is treated with the highest level of
                  confidentiality in accordance with advocate client privilege and professional ethics. BYLAWS does not collect personal data
                  indiscriminately and limits data collection to what is reasonably necessary for legitimate professional purposes.
                  </p>

                  <p className="mb-3">4. Lawful Basis and Purpose of Processing</p>

                  <p className="mb-3">
                  BYLAWS processes personal data only where there is a lawful basis to do so. Such processing is primarily undertaken for
                  the performance of legal services, compliance with legal and regulatory obligations, protection of legal rights, or pursuit of
                  legitimate professional interests. In many cases, data processing is necessary to comply with statutory obligations, court
                  procedures, regulatory requirements, internal evaluations or professional standards applicable to advocates and law firms.
                  </p>

                  <p className="mb-3">
                  The purposes for which data is processed include client onboarding, conflict checks, legal advisory, drafting, litigation,
                  regulatory filings, compliance assessments, transaction execution, dispute resolution, billing, record-keeping, internal
                  administration, recruitment and website management. In regulatory and litigation matters, data processing may be
                  necessary to defend or pursue legal claims, comply with court directions or respond to regulatory inquiries.
                  </p>

                  <p className="mb-3">
                  Where consent is exclusively mandatory under applicable law, BYLAWS shall obtain such consent however, in many legal
                  contexts, consent may not be the primary basis for processing due to overriding legal obligations or legitimate professional
                  necessity. This Policy is drafted to ensure that the Firm’s processing activities remain legally aligned with its role as a legal
                  service provider.
                  </p>

                  <p className="mb-3">5. Advocate–Client Privilege and Confidentiality</p>

                  <p className="mb-3">
                  All information received from clients or generated in the course of legal representation is protected by advocate–client
                  privilege and strict confidentiality obligations. BYLAWS recognises that confidentiality is fundamental to the practice of law
                  and undertakes to preserve such confidentiality in accordance with professional ethics and applicable law.
                  </p>

                  <p className="mb-3">
                  Client information shall not be disclosed except where disclosure is authorised by the client, required by law, mandated by
                  court or regulatory order, or necessary for the proper conduct of legal proceedings. Any disclosure to third parties, such as
                  co-counsel, experts, consultants or service providers, is undertaken strictly on a need-to-know basis.
                  </p>

                  <p className="mb-3">
                  The Firm expressly reserves all rights available under law to protect privileged communications and confidential information
                  from disclosure.
                  </p>

                  <p className="mb-3">6. Data Sharing, Disclosure and Cross-Border Transfers</p>

                  <p className="mb-3">
                  BYLAWS may disclose personal data to courts, tribunals, regulators, statutory authorities, opposing parties, co-counsel,
                  experts, investigators, auditors and service providers for lawful and professional purposes. Such disclosures are limited to
                  what is reasonably necessary and are subject to appropriate safeguards.
                  </p>

                  <p className="mb-3">
                  In matters involving cross-border transactions or international disputes, personal data may be transferred outside India
                  where required for legal representation or advisory services. Such transfers are undertaken in compliance with applicable
                  law and with due consideration to confidentiality and security obligations.
                  </p>

                  <p className="mb-3">
                  The Firm does not sell personal data. All disclosures are made to reduce legal risk, comply with obligations, serve the client,
                  assist in getting services or protect the Firm’s and clients’ legal interests.
                  </p>

                  <p className="mb-3">7. Data Security and Risk Management</p>

                  <p className="mb-3">
                  BYLAWS implements reasonable security practices and procedures to protect personal data against unauthorised access,
                  disclosure, alteration, or destruction. These measures include physical security controls, access restrictions, password
                  protection, confidentiality undertakings, and controlled IT systems. The Firm periodically reviews its data handling practices
                  to mitigate risks associated with unauthorised access or data breaches.
                  </p>

                  <p className="mb-3">
                  Given the inherent risks associated with electronic communication and data storage, BYLAWS does not guarantee absolute
                  security. However, the Firm adopts commercially reasonable and professionally appropriate safeguards consistent with its
                  role as a legal service provider.
                  </p>

                  <p className="mb-3">8. Data Retention and Disposal</p>

                  <p className="mb-3">
                  Personal data is retained only for as long as necessary to fulfil the purposes for which it was collected, comply with legal and
                  regulatory obligations, and protect legal interests. Given the nature of legal practice, certain records may be retained for
                  extended periods to comply with limitation laws, professional requirements, or risk management considerations.
                  </p>

                  <p className="mb-3">
                  Once data is no longer required, it may be securely archived or destroyed in accordance with internal policies. The Firm
                  reserves discretion in determining retention periods to minimise legal exposure.
                  </p>

                  <p className="mb-3">9. Rights of Individuals and Limitations</p>

                  <p className="mb-3">
                  Subject to applicable law, individuals may request access to, correction of, or information regarding their personal data.
                  However, such rights are subject to legal, professional, and confidentiality constraints. Requests that conflict with
                  advocate–client privilege, legal obligations, or the Firm’s risk management interests may be lawfully declined.
                  </p>

                  <p className="mb-3">10. Amendments, Governing Law and Disclaimer</p>

                  <p className="mb-3">
                  BYLAWS reserves the right to amend this Privacy Policy at any time to reflect changes in law, professional practice, or
                  operational requirements. This Policy shall be governed by the laws of India, and courts having jurisdiction over the Firm’s
                  principal office shall have exclusive jurisdiction.
                  </p>

                  <p className="mb-3">
                  This Policy does not constitute legal advice, does not create enforceable rights, and shall not be construed against the Firm.
                  It is intended solely to outline BYLAWS’s approach to privacy and data protection in a manner that reduces legal and
                  regulatory risk.
                  </p>
                  <h4 className="mb-4"><spam className="card_title">DISCLAIMER</spam></h4>
                  <p className="mb-3">BYLAWS Legal LLP</p>

                  <p className="mb-3">
                  This Disclaimer governs the access to, use of, and reliance upon the website, content, materials, communications, and
                  information made available by BYLAWS Legal LLP (“BYLAWS”, “the Firm”, “we”, “our” or “us”). The Firm is a limited liability
                  partnership engaged in the practice of law and allied professional services through advocates and legal professionals in
                  India.
                  </p>

                  <p className="mb-3">
                  This website and all content contained herein are provided strictly for general informational purposes only. Nothing on this
                  website is intended to constitute, nor shall it be construed as, legal advice, general advice or investment advice, legal
                  opinion, solicitation, advertisement, invitation, assurance, guarantee, representation or inducement of any kind.
                  </p>

                  <p className="mb-3">
                  The information, articles, updates, insights, explanations, summaries, and materials available on this website are not
                  intended to be relied upon as legal advice or opinion. Laws, regulations, judicial interpretations and regulatory practices vary
                  based on facts, jurisdiction, timing and context and generic information cannot substitute for tailored legal advice.
                  </p>

                  <p className="mb-3">
                  BYLAWS expressly disclaims any responsibility or liability for any action taken or not taken by any person based on the
                  content of this website. Visitors must not act, or refrain from acting, on the basis of any information available on this website
                  without seeking specific legal advice after full disclosure of relevant facts.
                  </p>

                  <p className="mb-3">
                  BYLAWS does not seek to solicit, advertise, or induce legal work through this website. Any information provided is purely
                  informational and is not intended to promote or market the Firm or its services in any manner prohibited under the
                  Advocates Act, 1961, the Bar Council of India Rules, or any other applicable professional regulations. Any transmission,
                  receipt, or viewing of information from this website shall not be construed as solicitation of legal work.
                  </p>

                  <p className="mb-3">
                  Accessing, browsing or using this website, or communicating with BYLAWS through this website, email, telephone, social
                  media, or any electronic medium, does not create an advocate–client relationship. An advocate–client relationship shall
                  arise only upon:
                  </p>

                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Completion of conflict checks</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Acceptance of instructions by BYLAWS</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Execution of a formal written engagement letter or agreement</p>

                  <p className="mb-3">
                  Until such time, BYLAWS owes no professional, fiduciary, or contractual duty to any visitor or correspondent.
                  </p>

                  <p className="mb-3">
                  Any information sent to BYLAWS prior to the establishment of a formal advocate client relationship shall not be treated as
                  confidential, privileged or protected, notwithstanding its nature or sensitivity except specified otherwise. Visitors are strongly
                  advised not to send confidential, proprietary, sensitive or privileged information through this website or unsolicited
                  communications. BYLAWS disclaims all liability for any loss of confidentiality, privilege, or legal protection arising from
                  unsolicited or unauthorised communications.
                  </p>

                  <p className="mb-3">
                  While reasonable efforts may be made to ensure accuracy, BYLAWS makes no representation or warranty, express or
                  implied, regarding the accuracy, completeness, reliability, adequacy, suitability or timeliness of any content on this website.
                  </p>

                  <p className="mb-3">
                  Legal and regulatory frameworks are subject to frequent change and the content may be outdated, incomplete or
                  superseded without notice. BYLAWS has no obligation to update, revise or correct any information and disclaims liability for
                  errors, omissions or inaccuracies.
                  </p>

                  <p className="mb-3">
                  To the maximum extent permitted by law, BYLAWS disclaims and excludes all liability, whether arising in contract, tort
                  (including negligence), strict liability, misrepresentation, breach of statutory duty, or otherwise, for any loss or damage arising
                  from or in connection with:
                  </p>

                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Use of or reliance on this website or its content</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Use the services of the bylaws Legal or its associated parties</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Inability to access or use the website</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Errors, omissions, interruptions, delays or inaccuracies</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Loss of data, profits, revenue, goodwill or reputation</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Consequential, indirect, incidental or punitive damages</p>

                  <p className="mb-3">
                  Nothing in this Disclaimer shall limit liability only to the extent such limitation is expressly prohibited by applicable law.
                  </p>

                  <p className="mb-3">
                  BYLAWS does not warrant that the website will be uninterrupted, error-free, secure, or free from viruses, malware, or
                  harmful components. The Firm disclaims liability for any technological failures, cyber incidents, data breaches, hacking,
                  unauthorised access, system outages, or third-party interference affecting the website or user devices. Users access and
                  use the website entirely at their own risk.
                  </p>

                  <p className="mb-3">
                  This website may contain links to third-party websites, platforms or resources. BYLAWS does not control, endorse, verify or
                  assume responsibility for the content, accuracy, security, availability, privacy practices or legality of any third-party sites or
                  content available on this website. Any interaction or action with third-party platforms or due to third party content is solely at
                  the user’s risk, and BYLAWS disclaims all liability arising therefrom.
                  </p>

                  <p className="mb-3">
                  This website is intended for informational use in India. BYLAWS does not represent that the content is appropriate, lawful, or
                  available for use in any other jurisdiction. Access from jurisdictions where such access may be unlawful is prohibited.Users
                  accessing the website from outside India do so at their own risk and are responsible for compliance with local laws.
                  </p>

                  <p className="mb-3">
                  All content on this website, including text, design, layout, graphics, logos, images, details, content and materials, is the
                  intellectual property of BYLAWS Legal LLP unless otherwise stated. Unauthorised copying, reproduction, distribution or
                  commercial use is strictly prohibited and may result in legal action.
                  </p>

                  <p className="mb-3">
                  Nothing on this website shall be construed as a waiver of privilege, confidentiality, professional protections or ethical
                  obligations available to BYLAWS or its advocates under law. The Firm expressly reserves all such rights.
                  </p>

                  <p className="mb-3">
                  To the fullest extent permitted by law, users agree to indemnify and hold harmless BYLAWS, its partners, associates,
                  employees, consultants, and affiliates from any claims, losses, liabilities, damages, costs, or expenses arising out of misuse
                  of the website, violation of this Disclaimer, or reliance on its content.
                  </p>

                  <p className="mb-3">
                  BYLAWS reserves the unrestricted right to amend, modify, or replace this Disclaimer at any time without prior notice.
                  Continued use of the website constitutes acceptance of the updated Disclaimer. This Disclaimer shall be governed by the
                  laws of India. Courts having jurisdiction over the Firm’s principal office shall have exclusive jurisdiction.
                  </p>

                  <p className="mb-3">
                  By accessing this website, users acknowledge that all risks associated with access, use, reliance, and communication rest
                  entirely with the user, and that BYLAWS shall bear liability only where such liability is expressly and mandatorily imposed by
                  law and cannot be contractually excluded.
                  </p>

                  </div>
                </div>
                </div>
            </div>
    );
  }
}

export default PrivacyPolicyInfo;
